export enum WebSocketEventEnum {
  LOGIN = 'LOGIN',
  OFFLINE = 'OFFLINE',
  CONNECT_SUCCESS = 'CONNECT_SUCCESS',
  TYPING = 'TYPING',
  STOP_TYPING = 'STOP_TYPING',
  JOIN_LIST_CONVERSATION = 'JOIN_LIST_CONVERSATION',
  LEAVE_LIST_CONVERSATION = 'LEAVE_LIST_CONVERSATION',
  JOIN_CONVERSATION = 'JOIN_CONVERSATION',
  LEAVE_CONVERSATION = 'LEAVE_CONVERSATION',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SEEN_MESSAGE = 'SEEN_MESSAGE',
  GET_MESSAGE_UNSEEN = 'GET_MESSAGE_UNSEEN',
}

export enum WebSocketTypeEnum {
  CHAT = 'CHAT',
  USE_APP = 'USE_APP',
}
